/**
 * Copyright 2023 Design Barn Inc.
 */

import type { ImageOptions } from './common';
import { LottieImageCommon } from './common';

export class LottieImage extends LottieImageCommon {
  public constructor(options: ImageOptions) {
    super(options);
  }
}
